/*
 * @Author: caiqin.xie
 * @since: 2023-06-09 14:56:39
 * @lastTime: 2023-11-07 15:40:16
 * @LastEditors: caiqin.xie
 * @message: 博客列表 推荐数据
 */
import React from "react";
import classnames from 'classnames'
import BlogItem from "../BlogItem";
import styles from "../../index.module.scss";
import { IBlogItem } from '@/common/types'

interface IProps {
  recommendBlogList: IBlogItem[]; // 推荐博客
  ctry: string;
  words: Record<string, string>;
}

const RecommendBlog = (props:IProps) => {
  const {recommendBlogList, ctry, words} = props

  return (
    <>
      {recommendBlogList && recommendBlogList.map((item,index) => (
        <a
          key={item.id}
          href={`/${ctry}/blog/${item.seoUrl}`}
          className={classnames({
            [styles['link-l-blog']]: index === 0,
            [styles['link-s-blog']]: index !== 0
          })}>
          <BlogItem
            type={index === 0 ? "main" : [1,2,3].includes(index) ? 'simple' : 'normal'}
            blogData={item}
            className={classnames({
              [styles['custom-l-blog']]: index === 0,
              [styles['custom-s-blog']]: index !== 0
            })}
            picClassName={styles['custom-blog-pic']}
            itemClassName={styles['custom-blog-item']} />
        </a>
      ))}
    </>
  )
}
export default RecommendBlog

